import React, { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import { Col } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

import { getCatalog, getCertificationStatus, getCertificationType } from 'utils';

import emetCertImg from 'assets/img/support-desk/reports/5.png';
import epstCertImg from 'assets/img/support-desk/reports/6.png';
import ExamInstructionsModal from './ExamInstructionsModal';


const CertificationItem = ({ cert }) => {
	const [certificationType, setCertificationType] = useState('');
	const [showInstructions, setShowInstructions] = useState(false);
	const [certData, setCertData] = useState(null);
	const navigate = useNavigate();

	useEffect(() => {
		setCertificationType(cert.catalog_id === 1 ? 'epst' : 'emet');
	}, [cert]);

	/**
	 * @function handleAccessCertification
	 * @description Verifica si el permiso del micrófono ha sido concedido (solo si es EPSt).
	 * Si es EMET, navega directamente. Si es EPSt, solicita permisos y continúa si se concede.
	 */
	const handleAccessCertification = async () => {
		if (cert.catalog_id !== 1) {
			// No requiere micrófono → EMET
			navigate(`/certification/${certificationType}`, { state: { ...cert } });
			return;
		}

		try {
			const permissions = await navigator.permissions.query({ name: 'microphone' });

			if (permissions.state === 'granted') {
				setCertData(cert);
				setShowInstructions(true);
			} else if (permissions.state === 'prompt') {
				const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
				if (stream) {
					setCertData(cert);
					setShowInstructions(true);
				}
			} else {
				Swal.fire({
					icon: 'error',
					title: 'Permiso de micrófono denegado',
					text: 'Necesitas permitir el uso del micrófono para continuar con esta certificación.',
					confirmButtonText: 'Entendido'
				});
			}
		} catch (error) {
			Swal.fire({
				icon: 'error',
				title: 'Permiso requerido',
				text: 'Debes permitir el uso del micrófono para iniciar esta certificación.',
				confirmButtonText: 'Aceptar'
			});
		}
	};

	return (
		<>
			<Col lg={6} xxl={6}>
				<Flex alignItems="center" className="px-4 py-x1 bg-light rounded-3 border position-relative">
					<img src={cert.catalog_id === 1 ? epstCertImg : emetCertImg} alt="" width="39" />
					<div className="ms-3 my-x1">
						<h5 className="fs-0 fw-semi-bold mb-2">
							<span
								onClick={handleAccessCertification}
								style={{ cursor: 'pointer' }}
								className="text-900 hover-primary stretched-link"
							>
								{getCatalog(cert.catalog_id)} {cert.description}
							</span>
						</h5>
						<h6 className="mb-0 text-600 mt-1">{`Tipo: ${getCertificationType(cert.certification_type)}`}</h6>
						<h6 className="mb-0 text-600 mt-1">{`Estado: ${getCertificationStatus(cert.status)}`}</h6>
						<h6 className="mb-0 text-600 mt-1">
							{cert.status === 2
								? `Fecha de terminado: ${moment.utc(cert.completed_date).format('DD/MM/YYYY')}`
								: `Disponible desde: ${moment.utc(cert.assigned_date).format('DD/MM/YYYY')} hasta: ${moment
										.utc(cert.closed_date)
										.format('DD/MM/YYYY')}`}
						</h6>
					</div>
				</Flex>
			</Col>
			{showInstructions && (
				<ExamInstructionsModal
					onStart={() => {
						setShowInstructions(false);
						navigate(`/certification/${certificationType}`, { state: { ...certData } });
					}}
				/>
			)}
		</>
	);
};

export default CertificationItem;